import React from 'react';
import { TrendingUp, Award, Globe, Shield } from 'lucide-react';

const AboutSection = () => {
  const stats = [
    { icon: TrendingUp, label: 'Experience', value: '40+ Years' },
    { icon: Award, label: 'Satisfied Customers', value: '1000+' },
    { icon: Globe, label: 'Industries Served', value: '20+' },
    { icon: Shield, label: 'Quality Standards', value: 'Global-Ready' }
  ];

  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 bg-bharat-blue rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-manufacturing-orange rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1684695749267-233af13276d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwZGlzdHJpYnV0aW9uJTIwbWF0ZXJpYWxzfGVufDB8fHx8MTc3MTgzOTQ5N3ww&ixlib=rb-4.1.0&q=85" 
                alt="Bharat Enterprises Warehouse"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-bharat-blue/50 to-transparent"></div>
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 border-t-4 border-manufacturing-orange">
              <div className="text-4xl font-bold text-bharat-blue">40+</div>
              <div className="text-steel-grey">Years of Excellence</div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="inline-block bg-manufacturing-orange/10 text-manufacturing-orange px-4 py-2 rounded-full text-sm font-semibold mb-4">
              About Bharat Enterprises
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-bharat-blue mb-6 leading-tight">
              Built on Quality. Delivered with Trust.
            </h2>
            
            <p className="text-lg text-steel-grey mb-6 leading-relaxed">
              Bharat Enterprises is a leading North India–based distributor of Titanium Dioxide (TiO₂), 
              operating in the high-volume, performance-driven industrial raw materials market.
            </p>
            
            <p className="text-lg text-steel-grey mb-6 leading-relaxed">
              With deep experience in commodity pricing, supply chain management, and relationship-led selling, 
              we have built long-term partnerships across multiple manufacturing sectors.
            </p>
            
            <p className="text-lg text-steel-grey mb-8 leading-relaxed">
              We operate with the discipline of a structured organization and the agility of a 
              relationship-driven enterprise.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div 
                    key={index}
                    className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg border border-gray-100 hover:border-manufacturing-orange transition-colors"
                  >
                    <div className="flex-shrink-0">
                      <div className="w-10 h-10 bg-bharat-blue/10 rounded-lg flex items-center justify-center">
                        <Icon className="w-5 h-5 text-bharat-blue" />
                      </div>
                    </div>
                    <div>
                      <div className="text-sm text-steel-grey">{stat.label}</div>
                      <div className="font-semibold text-bharat-blue">{stat.value}</div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Positioning Statement */}
            <div className="mt-8 p-6 bg-bharat-blue/5 border-l-4 border-bharat-blue rounded-r-lg">
              <p className="text-lg font-semibold text-bharat-blue italic">
                "A trusted Indian supplier with global-ready standards."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
